import { useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import {
  useCreate,
  useNotify,
  SimpleForm,
  Create,
  useResourceContext,
  required,
  useRefresh,
  useTranslate,
  maxLength,
  AutocompleteInput,
  TextInput,
} from "react-admin";
import SaveDeleteBtns from "../../saveDeleteBtns/SaveDeleteBtn";
import sanitizeData from "../../../utils/sanitizeData";
import SettingValueInput from "../common/SettingValueInput";

const validateName = [required(), maxLength(50)];
const validateValue = [required()];
const validateDesc = [maxLength(150)];

export default function SettingAddDialog({ open, setOpen }) {
  const [create] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();
  const resource = useResourceContext(); // cuman nama resource
  const translate = useTranslate();

  const save = useCallback(
    async (values) => {
      try {
        await create(
          resource,
          { data: sanitizeData(values) },
          {
            returnPromise: true,
            onSuccess: (data) => {
              notify("ra.notification.created", {
                messageArgs: { smart_count: 1 },
              });
              setOpen(false);
              refresh();
            },
          }
        );
      } catch (error) {
        if (error.body) {
          if (error.body && error.body.errors) {
            if (error.body.errors === "403") {
              // munculkan notifikasi erro ketika sudah approved
              notify("mine.notification.403_error", { type: "error" });
            } else {
              // The shape of the returned validation errors must match the shape of the form
              return error.body.errors;
            }
          } else if (error.status === 500) {
            notify(error.message, { type: "error" });
          }
        } else if (error.status === 500) {
          notify(error.message, { type: "error" });
        }
      }
    },
    [create]
  );

  const handleClose = (e, reason) => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted={false}
      PaperProps={{
        sx: {
          width: "100%",
        },
      }}
    >
      <Create title={" "} sx={{ "& .RaCreate-main": { mt: 0 } }}>
        <SimpleForm
          warnWhenUnsavedChanges
          onSubmit={save}
          toolbar={<SaveDeleteBtns />}
          mode="onBlur"
          reValidateMode="onBlur"
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 0,
            }}
          >
            <DialogTitle>{translate("mine.dialog.create_setting")}</DialogTitle>
            <IconButton onClick={handleClose} sx={{ mr: "11px" }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent
            sx={{
              alignSelf: "stretch",
            }}
          >
            {/* <TextInput
              variant="outlined"
              source="name"
              label="mine.label.name"
              fullWidth
              validate={validateName}
              helperText="Wajib pilih salah satu: CUSTOMER_DEBT_MAX_DAYS, SALE_RANKING_LAST_PERIOD"
            /> */}
            <AutocompleteInput
              variant="outlined"
              source="name"
              label="mine.label.name"
              fullWidth
              choices={[
                {
                  id: "CUSTOMER_DEBT_MAX_DAYS",
                  name: "CUSTOMER_DEBT_MAX_DAYS",
                },
                {
                  id: "SALE_RANKING_LAST_PERIOD",
                  name: "SALE_RANKING_LAST_PERIOD",
                },
                {
                  id: "MINIMAL_INCOME_FOR_INCENTIVE",
                  name: "MINIMAL_INCOME_FOR_INCENTIVE",
                },
                {
                  id: "SALE_DATE_CHANGE_LIMIT",
                  name: "SALE_DATE_CHANGE_LIMIT",
                },
                {
                  id: "MAX_SALE_BACK_DATE",
                  name: "MAX_SALE_BACK_DATE",
                },
                {
                  id: "TAX_POSTING_MODE",
                  name: "TAX_POSTING_MODE",
                },
                {
                  id: "CUSTOMER_CODE_MODE",
                  name: "CUSTOMER_CODE_MODE",
                },
              ]}
              validate={validateName}
            />
            <SettingValueInput
              variant="outlined"
              label="mine.label.value"
              fullWidth
              validate={validateValue}
            />
            <TextInput
              variant="outlined"
              source="description"
              label="mine.label.description"
              fullWidth
              multiline
              rows={3}
              validate={validateDesc}
            />
          </DialogContent>
        </SimpleForm>
      </Create>
    </Dialog>
  );
}
